import { module } from "angular";
import { DummyWidgetComponent } from "./DummyWidgetComponent";

module("mmGui").component("mmDummyWidget", new DummyWidgetComponent());
